import { fixedWidth } from "@/utils/strings";

const DEBUG_MODE = localStorage.getItem("debug");

window.setBusDebugMode = (activate) => {
  if (activate) {
    localStorage.setItem("debug", true);
  } else {
    localStorage.removeItem("debug");
  }
  location.reload();
};

export default class EventBus {
  constructor() {
    this.listeners = [];
  }

  emit(event, payload = null, fromWorker = false) {
    this.listeners.forEach((listener) => listener.handle(event, payload, fromWorker));
    if (!fromWorker && DEBUG_MODE) {
      console.info("EVENT", fixedWidth("BUS"), fixedWidth(event, 50), Date.now());
    }
  }

  unsubscribe(id) {
    const index = this.listeners.findIndex((c) => c.id === id);
    if (index !== null) {
      this.listeners.splice(index, 1);
    }
  }

  subscribe(callback) {
    if (this.listeners.indexOf(callback) >= 0) return;
    this.listeners.push(callback);
  }
}
